module.exports = __webpack_public_path__ + "static/media/8.e1b0fa4f.jpg";